export const SET_INSTALLMENT = "SET_INSTALLMENT";
export const SET_INSTALLMENTS = "SET_INSTALLMENTS";
export const SET_INSTALLMENTS_2 = "SET_INSTALLMENTS_2";
